import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import PrimaryButton, { PrimaryButtonProps } from 'components/partials/buttons/primary-button';
import GatsbyImageTag from 'components/partials/parts/gatsby-image-tag';

/**
 * Suggested image size 675x454
 */
export type CardProps = {
    gatsbyImageData?: IGatsbyImageData;
    headline: string;
    htmlContent: string;
    primaryButtonProps?: PrimaryButtonProps;
};

export type AlternatingImageContentRowsProps = {
    cards: CardProps[];
};

const Card: React.FC<CardProps> = ({ gatsbyImageData, headline, htmlContent, primaryButtonProps }) => (
    <>
        <div className="image-content-row__asset">
            <GatsbyImageTag image={gatsbyImageData} alt={headline} lazy={true} />
        </div>

        <div className="image-content-row__content">
            <div>
                <h2 className="headline">{headline}</h2>
                <div className="rtecontent" dangerouslySetInnerHTML={{ __html: htmlContent }} />
                {primaryButtonProps && <PrimaryButton {...primaryButtonProps} />}
            </div>
        </div>
    </>
);

const AlternatingImageContentRows: React.FC<AlternatingImageContentRowsProps> = ({ cards }) => (
    <div className="pattern pattern--alternating-rows">
        <div className="container">
            {cards.map((card, index) => (
                <div className={`image-content-row image-content-row--image-${index % 2 === 0 ? 'right' : 'left'}`}>
                    <Card {...card} />
                </div>
            ))}
        </div>
    </div>
);

export default AlternatingImageContentRows;